import { BaseComponent2 } from '../../_common/client/base-component2';
import { HelpfulReviewService } from './service/helpful-review-service';
import { ReportReviewService } from './service/report-review-service';
import { CustomerReviewTextExpander } from './service/customer-review-text-expander';
import { CustomerReviewLightbox } from '../../_common/client/customer-review-lightbox';

export class CustomerReviewItemComponent extends BaseComponent2 {
    public rootSelector = '.js_pdp_cr-item';

    constructor(
        private readonly helpfulReviewService: HelpfulReviewService,
        private readonly reportReviewService: ReportReviewService,
        private readonly textExpander: CustomerReviewTextExpander
    ) {
        super();
    }

    public async onReloadComponentEvent(): Promise<void> {
        return;
    }

    public async init(): Promise<void> {
        if (!this.isPresent()) return;

        const rootElement = this.getRootElement();
        this.textExpander.init(rootElement);
        if (rootElement.dataset.reviewCardVariant === 'summary-citation') return;

        this.helpfulReviewService.initButtons(rootElement);
        this.reportReviewService.initReportButton(rootElement);
        await CustomerReviewLightbox.init(rootElement, '.js_pdp_cr-item__images', '.js_pdp_cr-item__image', 'bottom');
    }
}
